export default __webpack_public_path__ + "static/logo-white-250ae169aa1086b8bbedfa4c18cb4a0d.svg";